// extracted by mini-css-extract-plugin
export default {"propertySize":"styles_propertySize__RRoEU","wrap":"styles_wrap__cuX2P","postfix":"styles_postfix__nB5Vo","to":"styles_to__ijsI1"};